import { ReactNode } from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";

type TNoteBoxProps = {
  label?: string;
  children: ReactNode;
  className?: string;
};

export function NoteBox({ label = "Note:", children, className }: TNoteBoxProps) {
  return (
    <div
      className={cn(
        "flex w-full flex-col items-start rounded-[6px] bg-innoveraYellow-50 px-[12px] py-[8px]",
        className
      )}
    >
      <p className="w-full text-[14px] leading-[22px] text-innoveraYellow-700">
        <span className="font-semibold text-innoveraYellow-300">{label}</span>
        <span className="ml-1">{children}</span>
      </p>
    </div>
  );
}
